<template>
    <footer class="text-center px-14 sm-max:px-5 bg-[#EEEEEE] py-10">
      <nuxt-img
          class="m-auto"
          width="192"
          height="63"
          loading="lazy"
          :alt="logoAlt"
          format="webp"
          :src="logoSrc"
      ></nuxt-img>
      <div class="inline-block mt-8 text-center transition-all duration-300 ease-linear border border-black rounded-xl hover:bg-footerHover hover:text-white">
        <a :href="`tel:${contactNumber}`" class="inline-block py-3 px-7 sm-max:px-4 sm-max:py-2">
          <span class="text-15 font-ww-regular"> {{ helpText }} </span>
          
          <br>

          <div class="flex items-center gap-x-1">
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.2715 3.90234C16.5715 4.25123 17.7568 4.93591 18.7086 5.88767C19.6604 6.83944 20.345 8.02479 20.6939 9.32478" stroke="currentColor" stroke-width="1.53284" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.4746 6.86328C15.2565 7.07093 15.9696 7.48158 16.5416 8.0536C17.1136 8.62563 17.5243 9.33871 17.7319 10.1206" stroke="currentColor" stroke-width="1.53284" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.86168 12.0263C9.65035 13.655 10.9673 14.9686 12.598 15.753C12.7183 15.81 12.8513 15.8347 12.984 15.8246C13.1167 15.8145 13.2445 15.77 13.3548 15.6956L15.7499 14.0957C15.8557 14.0239 15.978 13.9801 16.1053 13.9684C16.2326 13.9566 16.3609 13.9774 16.478 14.0286L20.9616 15.9542C21.1148 16.018 21.2428 16.1304 21.3259 16.2741C21.409 16.4178 21.4426 16.5848 21.4214 16.7494C21.2793 17.8585 20.7379 18.8779 19.8986 19.6167C19.0592 20.3556 17.9794 20.7633 16.8612 20.7635C13.4057 20.7635 10.0916 19.3908 7.64819 16.9474C5.20474 14.5039 3.83203 11.1899 3.83203 7.73435C3.83228 6.61614 4.23997 5.53633 4.97882 4.69698C5.71766 3.85762 6.73702 3.31624 7.84617 3.17414C8.01079 3.15299 8.17781 3.18655 8.32149 3.26964C8.46517 3.35273 8.57755 3.48076 8.64133 3.63399L10.567 8.12714C10.617 8.24244 10.638 8.36828 10.628 8.49358C10.6179 8.61888 10.5773 8.73979 10.5095 8.84566L8.90958 11.2791C8.83835 11.3891 8.79654 11.5156 8.78816 11.6464C8.77977 11.7773 8.80508 11.9081 8.86168 12.0263Z" stroke="currentColor" stroke-width="1.53284" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
            <span class="text-22">{{ contactNumber }}</span>
          </div>

        </a>
      </div>
   
      <div class="flex flex-col justify-center gap-4 mt-10 text-sm gap-x-16 sm-max:mt-6 md:flex-row font-ww-regular">
        © {{ companyName }}. {{ rightsText }} <a :href="termsLink" target="_blank">{{ termsText }}</a> <a :href="privacyLink" target="_blank">{{ privacyText }}</a>
      </div>
    </footer>
  </template>
  
  <script setup>
  
  defineProps({
    logoSrc: {
      type: String,
      default: '/assets/images/black-logo.svg'
    },
    logoAlt: {
      type: String,
      default: 'logo-lifeboost'
    },
    helpText: {
      type: String,
      default: 'Questions? Let Us Help You'
    },
    contactNumber: {
      type: String,
      default: '1-800-479-1596'
    },
    companyName: {
      type: String,
      default: 'Lifeboost Coffee'
    },
    rightsText: {
      type: String,
      default: 'All Rights Reserved'
    },
    termsLink: {
      type: String,
      default: 'https://lifeboostcoffee.com/pages/terms-conditions'
    },
    termsText: {
      type: String,
      default: 'Terms and Conditions'
    },
    privacyLink: {
      type: String,
      default: 'https://lifeboostcoffee.com/pages/privacy-policy'
    },
    privacyText: {
      type: String,
      default: 'Privacy Policy'
    }
  })
  
  defineBuilderComponent({
      friendlyName: "LifeboostFooter",
      canHaveChildren: true,
      inputs: [
          {
              name: "logoSrc",
              type: "file",
              allowedFileTypes: [
                  "jpeg",
                  "jpg",
                  "svg",
                  "png"
              ],
              required: true,
              defaultValue: "/assets/images/black-logo.svg"
          },
          {
              name: "logoAlt",
              type: "string",
              defaultValue: "logo-lifeboost"
          },
          {
              name: "helpText",
              type: "string",
              defaultValue: "Questions? Let Us Help You"
          },
          {
              name: "contactNumber",
              type: "string",
              defaultValue: "1-800-479-1596"
          },
          {
              name: "companyName",
              type: "string",
              defaultValue: "Lifeboost Coffee"
          },
          {
              name: "rightsText",
              type: "string",
              defaultValue: "All Rights Reserved"
          },
          {
              name: "termsLink",
              type: "string",
              defaultValue: "https://lifeboostcoffee.com/pages/terms-conditions"
          },
          {
              name: "termsText",
              type: "string",
              defaultValue: "Terms and Conditions"
          },
          {
              name: "privacyLink",
              type: "string",
              defaultValue: "https://lifeboostcoffee.com/pages/privacy-policy"
          },
          {
              name: "privacyText",
              type: "string",
              defaultValue: "Privacy Policy"
          }
      ]
  });
  </script>